import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Select } from '@telus-uds/components-web';

import request from '../../../../../utils/request';

const Province = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  const [provincesList, setProvincesList] = useState([]);
  const fieldError = 'provinces' in formErrors;

  useEffect(() => {
    (async () => {
      const result = await request.get('/provinces');
      setProvincesList(result.data.provinces);
    })();
  }, []);

  return (
    <Select
      label="Province *"
      placeholder="Please select..."
      validation={fieldError ? 'error' : undefined}
      feedback={fieldError ? formErrors.provinces.message : undefined}
      value={fieldData.provinces[0] || ''}
      onChange={(value) => {
        if (!value)
          setFormErrors(previousValue => ({
            ...previousValue,
            provinces: { message: 'Field is required' }
          }));
        else
          setFormErrors(previousValue => {
            const newValue = { ...previousValue };
            delete newValue.provinces;
            return newValue;
          });

        setFieldData(previousValue => ({
          ...previousValue,
          provinces: [value]
        }));
      }}
    >
      {provincesList && provincesList.map(province => (
        <Select.Item key={province.name} value={province.name}>
          {province.name}
        </Select.Item>
      ))}
    </Select>
  );
};

Province.propTypes = {
  formErrors: PropTypes.shape({
    provinces: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Province;
